import { useEffect, useState } from "react";

export const useRecentEmails = (username: string) => {
    const [emails, setEmails] = useState<string[]>([]);
    const RECENT_EMAILS_KEY = 'SSO.Login.RecentEmails';

    useEffect(() => {
        const recentEmails = localStorage.getItem(RECENT_EMAILS_KEY);
        if (recentEmails) {
            try {
                const parsedEmails = JSON.parse(recentEmails);
                if (Array.isArray(parsedEmails)) {
                    setEmails(parsedEmails);
                }
            } catch (error) {
                localStorage.removeItem(RECENT_EMAILS_KEY);
                setEmails([]);
            }
        }
    }, []);

    useEffect(() => {
        localStorage.setItem(RECENT_EMAILS_KEY, JSON.stringify(emails));
    }, [emails]);
            
    const addEmailToRecentEmails = (email: string) => {
        setEmails((prevEmails: any) => [email, ...prevEmails] );
    };
    
    const handleRecentEmailDeleteClick = (emailToRemove: string) => {
        setEmails((prevEmails: string[]) =>
            prevEmails.filter((email) => email !== emailToRemove)
        );
    };

    const recentEmailAdd = (email: string) => {
        if (emails.includes(email)) {
            handleRecentEmailDeleteClick(email);
        } else if (emails.length >= 5) {
            handleRecentEmailDeleteClick(emails[4]);
        }
    
        addEmailToRecentEmails(email);
    };

    const filteredEmails = emails.filter((email: string) =>
        email.toLowerCase().startsWith(username.toLowerCase())
    );

    return {filteredEmails, recentEmailAdd, handleRecentEmailDeleteClick};
}

